<template>
    <div>
        <el-card
                shadow="never"
                style="margin: 2px 0;"
        >
            <el-form
                    :model="filter"
                    :rules="rules"
                    label-width="120px"
                    ref="form"
            >
                <el-form-item label="日期" prop="date">
                    <el-date-picker
                            :clearable="false"
                            :editable="false"
                            :picker-options="options"
                            placeholder="請選擇要查詢的日期"
                            type="date"
                            v-model="filter.date"
                            value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="節次起訖" prop="periods">
                    <period-picker
                            :comparer="(b, e) => e >= b"
                            :options="periodOpt"
                            v-model="filter.periods"
                    ></period-picker>
                </el-form-item>
                <p>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;※週一至週五中午時段(12:10~13:00)為第16節
                </p>
                <el-button
                        @click="query"
                        icon="el-icon-search"
                        size="medium"
                        type="info"
                        :loading="loading.actions['booking']"
                >
                    查詢
                </el-button>
                <el-button
                        @click="reset"
                        size="medium"
                        icon="el-icon-refresh-left"
                >
                    重設
                </el-button>
            </el-form>
        </el-card>
        <el-divider>查詢結果</el-divider>
        <el-card
                shadow="never"
                style="margin: 2px 0; height: 400px"
        >
            <div v-if="vacancyRooms.length > 0">
                ※點擊教室移至借用畫面
            </div>
            <div v-if="vacancyRooms.length <= 0" style="text-align:center;">
                無空教室
            </div>
            <div style="max-height: 300px; overflow-y: auto; ">
                <el-button
                        v-for="r in vacancyRooms"
                        :key="r.id"
                        style="margin-bottom: 5px;"
                        @click="toBook(r)"
                >
                    {{r.name}}
                </el-button>
            </div>
        </el-card>

    </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex';
import PeriodPicker from '../PeriodPicker';
import moment from 'moment';
import {TotalPeriods} from '@/constants';

const defaultFilter = {
        date: moment().format('YYYY-MM-DD'),
        periods: [],
    };
    export default {
        name: 'VacancyRoomQuery',
        components: {
            PeriodPicker
        },
        data: () => ({
            vacancyRooms: [],
            filter: {...defaultFilter},
            rules: {
                date: [
                    {required: true, message: '請輸入要查詢的日期', trigger: 'blur'},
                ],
                periods: [
                    {
                        required: true,
                        validator: (rule, value, callback) => {
                            if (!value || value.length < 2 || value.some(v => !v)) {
                                callback(new Error('請選擇節次起訖'));
                            }
                            callback();
                        }
                    }
                ]
            },
            firstDayOfWeek: 1
        }),
        computed: {
            ...mapState(['loading']),
            ...mapGetters('setting', ['schoolYear', 'semester']),
            ...mapState('setting', ['sys']),
            periodOpt() {
                return [...new Array(TotalPeriods).keys()].map(k => ({value: k + 1, key: k + 1, label: `第${k + 1}節`}));
            },

            options(){
                const {dateEnd = moment().format('YYYY-MM-DD')} = this.sys;
                return {
                    disabledDate(date) {
                        return moment().isAfter(date, 'd')
                                || moment(dateEnd).isBefore(date, 'd');
                    }
                }
            }
        },
        methods: {
            ...mapActions('booking', {
                getVacancyClassrooms: 'getVacancyClassroomsAction'
            }),
            reset() {
                this.filter = {...defaultFilter};
                this.vacancyRooms.splice(0);
            },
            async query() {
                const {form} = this.$refs;

                await form.validate(async (valid) => {
                    if (valid) {
                        const {periods, date} = this.filter;
                        const {schoolYear, semester} = this;
                        const [begin, end] = periods;
                        const rooms = await this.getVacancyClassrooms({
                            schoolYear, semester, date,
                            begin, end
                        });
                        this.vacancyRooms.splice(0);
                        this.vacancyRooms = [...rooms];
                    }
                });
            },

            toBook({id:roomId}){
                const {periods, date} = this.filter;
                this.$router.push({
                    name: 'booking/normal',
                    params:{
                        roomId,
                        date,
                        periods
                    }
                })
            }
        },

    }
</script>

<style>

</style>
